import script from "./IntercomWidget.vue?vue&type=script&lang=js"
export * from "./IntercomWidget.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__